import { TurnBuyersSortBy } from '../../enums/TurnBuyersSortBy';
import { TurnPortfoliosSortBy } from '../../enums/TurnPortfoliosSortBy';
import { VehicleType } from '../../enums/TurnVehicleType';
import { FilterTurnAction, FilterTurnActionType, MinMaxFilter } from './TurnFilterActions';

export type TurnFilterState = {
  sortBy: TurnPortfoliosSortBy;
  buyerSortBy: TurnBuyersSortBy | null;
  years: number[];
  models: string[];
  trims: string[];
  brands: string[];
  vehicleTypes: VehicleType[];
  daysOnLot: MinMaxFilter;
  mileage: MinMaxFilter;
  price: MinMaxFilter;
  search: string;
};

export const initialTurnFilterState: TurnFilterState = {
  sortBy: TurnPortfoliosSortBy.CUSTOMER_MATCHES_DESC,
  buyerSortBy: null,
  years: [],
  models: [],
  trims: [],
  brands: [],
  vehicleTypes: [],
  daysOnLot: {
    min: -1,
    max: -1,
  },
  mileage: {
    min: -1,
    max: -1,
  },
  price: {
    min: -1,
    max: -1,
  },
  search: '',
};

export const turnFilterReducer = (
  state: TurnFilterState = initialTurnFilterState,
  action: FilterTurnAction,
): TurnFilterState => {
  switch (action.type) {
    // case FiltersActionsType.SET_PAGINATION:
    //   return {
    //     ...state,
    //     pagination: action.payload
    //   };
    case FilterTurnActionType.SET_SORT_BY_TURN:
      return {
        ...state,
        sortBy: action.payload,
      };
    case FilterTurnActionType.SET_SORT_BY_BUYER:
      return {
        ...state,
        buyerSortBy: action.payload,
      };
    case FilterTurnActionType.FILTERS_RESET:
      return {
        ...initialTurnFilterState,
      };
    case FilterTurnActionType.SET_YEARS:
      return {
        ...state,
        years: action.payload,
      };
    case FilterTurnActionType.SET_MODELS:
      return {
        ...state,
        models: action.payload,
      };
    case FilterTurnActionType.SET_TRIMS:
      return {
        ...state,
        trims: action.payload,
      };
    case FilterTurnActionType.SET_VEHICLE_TYPES:
      return {
        ...state,
        vehicleTypes: action.payload,
      };
    case FilterTurnActionType.SET_BRANDS:
      return {
        ...state,
        brands: action.payload,
      };
    case FilterTurnActionType.SET_DAYS_ON_LOT:
      return {
        ...state,
        daysOnLot: action.payload,
      };
    case FilterTurnActionType.SET_MILEAGE:
      return {
        ...state,
        mileage: action.payload,
      };
    case FilterTurnActionType.SET_PRICE:
      return {
        ...state,
        price: action.payload,
      };
    case FilterTurnActionType.SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    default:
      return state;
  }
};
